export enum Partner {
  DEFAULT = 'default',
  JAMES_HARDIE = 'james-hardie',
  MUELLER = 'mueller',
  AMERIPRO = 'ameripro',
  HANSONS = 'hansons',
  INFINITY = 'infinity',
  ABC_SEAMLESS = 'abc_seamless',
  PRIDDY = 'priddy',
  PRIDDY_JH = 'priddy-jh',
  WINDOWS_ROYAL = 'windows-royal',
  WINDOWS_CERTAINTEED = 'windows-certainteed',
  EXTERIORS_COMPANY = 'exteriors-company',
  B_B_SIDING = 'b-b-siding',
}
